module.exports = __webpack_public_path__ + "img/img-logo.9aa1f040.png";